export default __webpack_public_path__ + "static/media/empty-message-box.688b673b.svg";